export const formatMoney = (amount: any) => {
  if (!amount) return;
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(amount);
};
